import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../../../../../actions/utilAction';

export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqActiveTargets`;
export const POST_PATIENT_SKILL_ACQ_COLLECT_DATA = `${API_URL}/api/CollectData/SavePatientSkillsAcquisitionCollectedData`;
export const GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API = `${API_URL}/api/CollectData/GetPatientSkillsAcqPreviousTrial`;
export const GET_PATIENT_SKILL_ACQ_COLLECTED_Data_LIST_API = `${API_URL}/api/CollectData/GetPatientSkillsAcqCollectedData`;
export const DELETE_PATIENT_SKILL_ACQ_COLLECTED_DATA = `${API_URL}/api/CollectData/DeletePatientSkillsAcqCollectedData`;
export const GET_PATIENT_SKILL_ACQ_TASK_ANALYSIS_LIST_API = `${API_URL}/api/CollectData/GetPatientSkillsAcqTaskAnalysis`;
export const DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API = `${API_URL}/api/CollectData/DeletePatientSkillsAcqCollectedData`;
export const GET_PATIENT_SKILL_ACQ_SELECTED_PROGRAMS_FOR_TARGET_API = `${API_URL}/api/CollectData/GetPatientProgramsByProgramIds`;
export const GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_NEWFLOW_API = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqActiveTargetsNewFlow`;
export const DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API_NEW_FLOW = `${API_URL}/api/CollectData/DeletePatientSkillsAcqCollectedData_NewFlow`;
export const GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API_NEW_FLOW = `${API_URL}/api/CollectData/GetPatientSkillsAcqPreviousTrial_NewFlow`;
export const POST_PATIENT_SKILL_ACQ_COLLECT_FREQUENCY_DATA = `${API_URL}/api/CollectData/SavePatientSkillsAcquisitionCollectedDataFrequency`;
export const POST_PATIENT_SKILL_ACQ_COLLECT_DURATION_DATA = `${API_URL}/api/CollectData/SavePatientSkillsAcquisitionCollectedDataDuration`;
export const GET_PATIENT_SKILL_ACQ_DOMAIN_PATIENT_ID = `${API_URL}/api/PatientSkillAcquisitionDomain/GetPatientSkillAcqDomainsByPatientId`;
export const GET_PATIENT_SKILL_ACQ_PROGRAM_DOMAIN_ID_PATIENT_ID = `${API_URL}/api/PatientSkillAcquisitionProgram/GetPatientSkillAcqProgramsByDomainIdAndPatientId`;
export const GET_PATIENT_SKILL_ACQ_TARGET_PROGRAM_PATIENT_ID = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqTargetsByProgramIdAndPatientId`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const  GET_PATIENT_SKILL_ACQ_COLLECT_NEW_FLOW = `${API_URL}/api/CollectData/GetPatientSkillsAcqCollectedData_NewFlow`;
// export const GET_SKILL_ACQ_COLLECTEDDATA_BY_TARGETID = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqCollectetDataByProgramIdAndTargetId`
export const GET_SKILL_ACQ_COLLECTEDDATA_BY_ID = `${API_URL}/api/PatientSkillAcquisitionTarget/GetPatientSkillAcqCollectetDataByCollectedDataId`


export const PatientSkillAcqActiveTargetListActionTypes = {
    get_patientSkillAcqActiveTargetList: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_API'),
    post_patientSkillAcqCollectData: createRequestActionTypes('POST_PATIENT_SKILL_ACQ_COLLECT_DATA'),
    get_patientSkillAcqPreviousTrialList :  createRequestActionTypes('GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API'),
    get_patientSkillAcqCollectedDataList: createRequestActionTypes('POST_PATIENT_SKILL_ACQ_COLLECTED_DATA_LIST'),
    delete_patientSkillAcqCollectedData: createRequestActionTypes('DELETE_PATIENT_SKILL_ACQ_COLLECTED_DATA'),
    get_patientSkillAcqTaskAnalysisList: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_TASK_ANALYSIS_LIST'),
    delete_patientSkillAcqPrevTrial: createRequestActionTypes('DELETE_PATIENT_SKILL_ACQ_PRE_TRIAL'),
    get_patientSkillAcqSelectedProgramForTarget: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_SELECTED_PROGRAMS_FOR_TARGET_API'),
    get_patientSkillAcqActiveTargetListNewFlow: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_NEWFLOW_API'),
    get_patientSkillAcqPreviousTrialListNewFlow :  createRequestActionTypes('GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_NEWFLOW_API'),
    post_patientSkillAcqCollectFrequencyData: createRequestActionTypes('POST_PATIENT_SKILL_ACQ_COLLECT_FREQUENCY_DATA'),
    post_patientSkillAcqCollectDurationData: createRequestActionTypes('POST_PATIENT_SKILL_ACQ_COLLECT_DURATION_DATA'),
    set_isRecordDurationRenderTrueSkAq: createRequestActionTypes('SET_IS_RECORD_DURATION_RENDER_TRUE_SKAQ'),
    start_recordDurationTimerSkAq: createRequestActionTypes('START_RECORD_DURATION_TIMER_SKAQ'),
    start_secondsElapsedSkAq: createRequestActionTypes('START_SECONDS_ELAPSED_SKAQ'),
    get_patientSkillAcqDomainPatientId : createRequestActionTypes('GET_PATIENT_SKILL_ACQ_ACTIVE_DOMAIN_PATIENT_ID'),
    get_patientSkillAcqProgramDomainIdPatientId : createRequestActionTypes('GET_PATIENT_SKILL_ACQ_PROGRAM_DOMAIN_ID_PATIENT_ID'),
    get_patientSkillAcqTargetPatientId : createRequestActionTypes('GET_PATIENT_SKILL_ACQ_TARGET_PROGRAM_PATIENT_ID '),
    get_master_data: createRequestActionTypes('GET_LEDGER_MASTER_DATA'),
    get_patientSkillAcqCollectDataNewFlow: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_COLLECT_NEW_FLOW'),
    get_skillAcqCollectedDataBytTargetId: createRequestActionTypes('GET_SKILL_ACQ_COLLECTEDDATA_BY_TARGETID'),
    enable_todaysdata: createRequestActionTypes('ENABLE_TODAYSDATA'),
    desable_todaysdata: createRequestActionTypes('DESABLE_TODAYSDATA'),
    get_skillAcqCollectedDataById: createRequestActionTypes('GET_SKILL_ACQ_COLLECTEDDATA_BY_ID'),
    get_patientSkillAcqCollectDataNewFlowReset: createRequestActionTypes('GET_PATIENT_SKILL_ACQ_COLLECT_NEW_FLOW_RESET'),
    setCollapseMenuId: createRequestActionTypes("SET_COLLAPSE_MENU_ID"),
    setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse:createRequestActionTypes('SET_IS_EVENT_OCCURE_PATIENT_SKILL_ACQ_COLLECT_DATA_NEW_FLOW_FALSE'),
}; 

export const MODULE = 'DCPATIENT_SKILLAQUISITIONTARGET';


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/constants/ApiConstants.js